// extracted by mini-css-extract-plugin
module.exports = {"container":"TextSwitch_container__3H4d0","button":"TextSwitch_button__2hoeg","selected-button":"TextSwitch_selected-button__noZ4K"};